var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaServerzugang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#556080;}.cls-3{fill:#38454f;}.cls-4{fill:#8697cb;}.cls-5{fill:#26b999;}.cls-6{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.75,54.37H16.81A8.8,8.8,0,0,1,8,45.56V16.81A8.8,8.8,0,0,1,16.81,8H140.75a8.81,8.81,0,0,1,8.81,8.81V45.56a8.81,8.81,0,0,1-8.81,8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.75,100.74H16.81A8.8,8.8,0,0,1,8,91.94V63.18a8.81,8.81,0,0,1,8.81-8.81H140.75a8.82,8.82,0,0,1,8.81,8.81V91.94a8.81,8.81,0,0,1-8.81,8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.75,147.13H16.81A8.81,8.81,0,0,1,8,138.32V109.55a8.81,8.81,0,0,1,8.81-8.81H140.75a8.82,8.82,0,0,1,8.81,8.81v28.76a8.82,8.82,0,0,1-8.81,8.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.72,31.19a8.54,8.54,0,1,1-8.53-8.54,8.53,8.53,0,0,1,8.53,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130,27.52a2.45,2.45,0,1,1-2.45-2.43A2.44,2.44,0,0,1,130,27.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.28,27.52a2.45,2.45,0,1,1-2.45-2.43,2.44,2.44,0,0,1,2.45,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.92,34.85a2.44,2.44,0,1,1-2.44-2.44,2.44,2.44,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.15,34.85a2.44,2.44,0,1,1-2.43-2.44,2.43,2.43,0,0,1,2.43,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.52,27.52a2.45,2.45,0,1,1-2.45-2.43,2.44,2.44,0,0,1,2.45,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.39,34.85A2.44,2.44,0,1,1,113,32.41a2.43,2.43,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.74,27.52a2.44,2.44,0,1,1-2.43-2.43,2.42,2.42,0,0,1,2.43,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.63,34.85a2.45,2.45,0,1,1-2.44-2.44,2.44,2.44,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91,27.52a2.44,2.44,0,1,1-2.44-2.43A2.42,2.42,0,0,1,91,27.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.87,34.85a2.45,2.45,0,1,1-2.44-2.44,2.44,2.44,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.72,77.56A8.54,8.54,0,1,1,31.19,69a8.54,8.54,0,0,1,8.53,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130,73.91a2.45,2.45,0,1,1-2.45-2.45A2.43,2.43,0,0,1,130,73.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.28,73.91a2.45,2.45,0,1,1-2.45-2.45,2.43,2.43,0,0,1,2.45,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.92,81.22a2.44,2.44,0,1,1-2.44-2.44,2.45,2.45,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.15,81.22a2.44,2.44,0,1,1-2.43-2.44,2.44,2.44,0,0,1,2.43,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.52,73.91a2.45,2.45,0,1,1-2.45-2.45,2.43,2.43,0,0,1,2.45,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.39,81.22A2.44,2.44,0,1,1,113,78.78a2.44,2.44,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.74,73.91a2.44,2.44,0,1,1-2.43-2.45,2.42,2.42,0,0,1,2.43,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.63,81.22a2.45,2.45,0,1,1-2.44-2.44,2.45,2.45,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91,73.91a2.44,2.44,0,1,1-2.44-2.45A2.42,2.42,0,0,1,91,73.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.87,81.22a2.45,2.45,0,1,1-2.44-2.44,2.45,2.45,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.72,123.93a8.54,8.54,0,1,1-8.53-8.54,8.54,8.54,0,0,1,8.53,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130,120.28a2.45,2.45,0,1,1-2.45-2.45,2.45,2.45,0,0,1,2.45,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.28,120.28a2.45,2.45,0,1,1-2.45-2.45,2.45,2.45,0,0,1,2.45,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.92,127.59a2.44,2.44,0,1,1-2.44-2.44,2.45,2.45,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.15,127.59a2.44,2.44,0,1,1-2.43-2.44,2.44,2.44,0,0,1,2.43,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.52,120.28a2.45,2.45,0,1,1-2.45-2.45,2.45,2.45,0,0,1,2.45,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.39,127.59a2.44,2.44,0,1,1-2.44-2.44,2.44,2.44,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.74,120.28a2.44,2.44,0,1,1-2.43-2.45,2.43,2.43,0,0,1,2.43,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.63,127.59a2.45,2.45,0,1,1-2.44-2.44,2.45,2.45,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91,120.28a2.44,2.44,0,1,1-2.44-2.45A2.44,2.44,0,0,1,91,120.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.87,127.59a2.45,2.45,0,1,1-2.44-2.44,2.45,2.45,0,0,1,2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152,122.72a29.29,29.29,0,1,1-29.28-29.29A29.28,29.28,0,0,1,152,122.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.75,108.5a2.45,2.45,0,0,0-3.4.62L121.7,128.74l-9.65-7.92A2.44,2.44,0,1,0,109,124.6l11.68,9.59a2.43,2.43,0,0,0,1.55.55l.33,0a2.44,2.44,0,0,0,1.67-1l15.17-21.78a2.46,2.46,0,0,0-.62-3.41Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaServerzugang);
export default __webpack_public_path__ + "static/media/ka_serverzugang.b9eaf51d8f849004d1c341156785190d.svg";
export { ForwardRef as ReactComponent };